<template>
    <v-expand-transition>                            
        <v-card
            width="250"
            class="mx-auto"
            transition="scroll-y-transition"
            v-show="expand"
        >
            <v-toolbar
                color="primary"
                dark
            >
                <v-toolbar-title>Select Class</v-toolbar-title>
            </v-toolbar>
                <div style="max-height: 400px; width: 250px; overflow-y: auto">    
                <v-list light >
                    <v-list-group
                        v-for="item in formClasses"
                        :key = "item.title"
                        v-model="item.active"
                        :prepend-icon="item.action"
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                            v-for="subItem in item.items"
                            :key="subItem.title"
                            @click="setSelectedClass(subItem.title)"                                       
                        >
                            <v-list-item-content>
                                <v-list-item-title >
                                    {{ subItem.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </div>
        </v-card>
    </v-expand-transition>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default{
    props: {
        expand: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        expand (newVal) {
            if(newVal){
               this.setFormClasses();
            }
        }
    },

    computed:{
        ...mapGetters({
            //
        })
    },

    data: () => ({
        formClasses: [],
    }),

    methods: {
        ...mapActions({
            getFormClassesCocurricular: 'markSheet/getFormClassesCocurricular',
            getCocurricularStudents: 'markSheet/getCocurricularStudents',
            getCocurricularClubs: 'markSheet/getCocurricularClubs',
        }),

        ...mapMutations({
            setCocurricularClass: 'markSheet/setCocurricularClass',
            setMarksheetLoading: 'markSheet/setMarkSheetLoading',
        }),

        async setFormClasses () {
            const { data } = await this.getFormClassesCocurricular();
            this.mapFormClasses(data);
        },

         mapFormClasses (data) {
            if(data.length > 0){                    
                    let form1Classes = [];
                    let form2Classes = [];
                    let form3Classes = [];
                    let form4Classes = [];
                    let form5Classes = [];
                    let form6Classes = []; 
                    data.forEach(record => {
                        switch(record.form_level){
                            case "1":
                            form1Classes.push({
                                title: record.id
                            });
                            break;
                            case "2":
                            form2Classes.push({
                                title: record.id
                            });
                            break;
                            case "3":
                            form3Classes.push({
                                title: record.id
                            });
                            break;
                            case "4":
                            form4Classes.push({
                                title: record.id
                            });
                            break;
                            case "5":
                            form5Classes.push({
                                title: record.id
                            });
                            break;
                            case "6":
                            form6Classes.push({
                                title: record.id
                            });
                            break;
                        }                
                    });
                    this.formClasses.push({
                        title: 'Form 1',
                        action: 'mdi-school',                
                        items: form1Classes
                    });
                    this.formClasses.push({
                        title: 'Form 2',
                        action: 'mdi-school',                
                        items: form2Classes
                    });
                    this.formClasses.push({
                        title: 'Form 3',
                        action: 'mdi-school',                
                        items: form3Classes
                    });
                    this.formClasses.push({
                        title: 'Form 4',
                        action: 'mdi-school',                
                        items: form4Classes
                    });
                    this.formClasses.push({
                        title: 'Form 5',
                        action: 'mdi-school',                
                        items: form5Classes
                    });
                    if(form6Classes.length != 0){
                        this.formClasses.push({
                            title: 'Form 6',
                            action: 'mdi-school',                
                            items: form6Classes
                        });
                    }
                }
        },
        
        async setSelectedClass(title){
            this.setCocurricularClass(title)
           
            this.$emit('close-classes');
            setTimeout(() => {
                this.setMarksheetLoading(true);
            }, 600);
            try {
                const [
                    { data: dataStudents },
                    { data: dataClubs },
                ] = await Promise.all([
                    this.getCocurricularStudents(),
                    this.getCocurricularClubs(),
                ])
                this.setMarksheetLoading(false);
                this.$emit('display-cocurricular-marksheet', dataStudents, dataClubs);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setMarksheetLoading(false);
            }
            
        },
        
    }
}
</script>
